<!--
 * @Author: WGL
 * @Date: 2023-06-21 09:23:33
 * @LastEditors: WGL 958897276@qq.com
 * @LastEditTime: 2025-10-29 14:09:45
 * @Description: 
-->
<template>
  <el-dialog
    v-model="dialogVisible"
    append-to-body
    center
    destroy-on-close
    :title="dialogTitle"
    top="3vh"
    width="45%"
    @close="handleClsoeDialog"
  >
    <el-tabs v-model="activeName" class="demo-tabs">
      <el-tab-pane
        v-for="(item, index) in typeList"
        :key="index"
        :label="item.label"
        :name="item.key"
      />
    </el-tabs>
    <div style="max-height: 80vh" class="oy">
      <div v-if="activeName === 'etka'">
        <div v-if="oemCodeInfo.etka">
          <base-table :config="etkaTableConfig">
            <template #brandTitle="{ scope }">
              <div>{{ scope?.brand?.title }}</div>
            </template>
            <template #partImageNum="{ scope }">
              <div>
                {{
                  scope?.part?.partInfo?.no
                    ? `(${scope?.part?.partInfo?.no})`
                    : ''
                }}
              </div>
            </template>
          </base-table>
        </div>
        <el-empty v-else :description="t('暂无数据')" />
      </div>
      <div v-else-if="activeName === 'ford'">
        <div v-if="oemCodeInfo.ford">
          <DesHeader :title="t('基本信息')" />
          <div>
            <div
              v-for="(item, index) in baseFordInfo"
              :key="index"
              class="fx ptb2"
            >
              <div class="w80">{{ item.title }}</div>
              <div class="ex g3">{{ item.value }}</div>
            </div>
          </div>
          <DesHeader class="mt15" :title="t('图纸信息')" />
          <div class="fx">
            <div v-for="(item, index) in fordImgList" class="mr5" :key="index">
              <base-image class="wh200" fit="contain" :src="item.img" />
              <div class="tc b g3 ptb5">{{ item.title }}</div>
            </div>
          </div>
          <DesHeader class="mt15" :title="t('适配车型')" />
          <el-table :data="fordAdaptParts" border stripe>
            <el-table-column label="序号" type="index" width="70" />
            <el-table-column
              v-for="(col, i) in fordColumns"
              :key="i"
              :label="col.label"
              :prop="col.prop"
              :width="col.width"
            />
          </el-table>
        </div>
        <el-empty v-else :description="t('暂无数据')" />
      </div>
      <div v-else-if="activeName === 'vin'">
        <div v-if="oemCodeInfo?.vin?.length">
          <base-table :config="vinTableConfig" table-height="65vh">
            <template #vehicleVin="{ scope }">
              <el-popover
                :persistent="false"
                placement="right"
                trigger="click"
                :width="500"
              >
                <template #reference>
                  <div class="c0 cp" @click="handleGetVinVehicle(scope)">
                    {{ t('查看') }}
                  </div>
                </template>
                <el-table :data="gridData" max-height="70vh">
                  <el-table-column property="Detail" label="名称" />
                  <el-table-column
                    label="版本"
                    property="Sales_version"
                    width="90"
                  />
                  <el-table-column label="指导价" property="Price" width="90" />
                </el-table>
              </el-popover>
            </template>
          </base-table>
        </div>
        <el-empty v-else :description="t('暂无数据')" />
      </div>
      <div v-else-if="activeName === 'google'">
        <div v-if="oemCodeInfo?.google"></div>
        <el-empty v-else :description="t('暂无数据')" />
      </div>
    </div>
  </el-dialog>
</template>

<script>
  // 基础产品编码组件
  import { defineComponent, reactive, toRefs, computed } from 'vue'
  import { t } from '@/utils/i18n'
  import { getRequest } from '@/api/api'
  export default defineComponent({
    name: 'BaseOemSearch',
    components: {},
    props: {},
    emits: ['close'],
    setup(props, { emit }) {
      const baseImg = 'https://cos.autoparts.jinweinet.com'
      const state = reactive({
        oemCodeInfo: {},
        dialogVisible: false,
        oemCode: '',
        dialogTitle: '',
        activeName: '',
        gridData: [],
      })
      const typeList = computed(() => [
        { label: `ETKA(${state.oemCodeInfo?.etka?.length || 0})`, key: 'etka' },
        { label: `FORD(${state.oemCodeInfo?.ford?.length || 0})`, key: 'ford' },
        { label: `VIN(${state.oemCodeInfo?.vin?.length || 0})`, key: 'vin' },
        // { label: 'Google搜图', key: 'google' },
      ])
      const getFordImg = (img, type = 'assemimgs') => {
        // 使用正则判断 img 字符串的类型，以构建正确的图片 URL
        if (!img) {
          return '' // 如果 img 为空，返回空字符串或默认占位图 URL
        }
        // 1. 判断 img 是否已经是完整的 HTTP/HTTPS URL。如果是，则直接返回。
        if (/^https?:\/\//i.test(img)) {
          return img
        }
        // 2. 如果 img 包含 '/.png'，则返回空字符串。
        if (img.includes('/.png')) {
          return ''
        }
        // 3. 构建完整的图片 URL。
        return `${baseImg}/ford/${type}/${img}`
      }
      const baseFordInfo = computed(() => {
        return [
          { title: '名称', value: state.oemCodeInfo?.ford?.title || '-' },
          { title: '位置编号', value: state.oemCodeInfo?.ford?.num || '-' },
          {
            title: '所属分类',
            value: state.oemCodeInfo?.ford?.cataName || '-',
          },
          {
            title: '适用车型',
            value: state.oemCodeInfo?.ford?.models
              ? JSON.parse(state.oemCodeInfo?.ford?.models).join('、')
              : '-',
          },
          {
            title: '使用年份',
            value: `${state.oemCodeInfo?.ford?.yearmin}-${state.oemCodeInfo?.ford?.yearmax}`,
          },
        ]
      })
      const fordImgList = computed(() => {
        return [
          {
            title: '图纸',
            img: getFordImg(state.oemCodeInfo?.ford?.assemImg),
          },
          {
            title: '部件',
            img: getFordImg(state.oemCodeInfo?.ford?.partImg, 'partimgs'),
          },
        ]
      })
      const fordColumns = [
        { label: '车型', prop: 'modelName', width: 130 },
        { label: '年份', prop: 'year', width: 80 },
        { label: '型号', prop: 'trimName' },
        { label: '发动机', prop: 'drivelineName' },
      ]
      const fordAdaptParts = computed(() => {
        return state.oemCodeInfo?.ford?.parts
          ? JSON.parse(state.oemCodeInfo?.ford?.parts)
          : []
      })
      const etkaTableColumns = [
        { label: '序号', type: 'index', width: 70 },
        {
          label: '品牌',
          prop: 'brand.image',
          width: 80,
          isImg: true,
          columnCls: 'fv fxmc',
          slotSufName: 'brandTitle',
        },
        { label: '市场/地区', prop: 'market.title', width: 120 },
        { label: '车型', prop: 'vehicle.title', width: 150 },
        {
          label: '部件图',
          prop: 'part.image',
          width: 150,
          isImg: true,
          columnCls: 'fv fxmc',
          slotSufName: 'partImageNum',
        },
        {
          label: '部件信息',
          prop: 'part.partInfo.title',
          minWidth: 150,
          valFun: (row) => {
            let str = `${row?.part?.partInfo?.title} (${row?.part?.year})`
            if (row?.part?.partInfo?.pos) {
              str += ` (${row?.part?.partInfo?.pos})`
            }
            return str
          },
        },
      ]
      let etkaTableConfig = reactive({
        searchBtnInline: true,
        headerActions: {
          list: [''],
        },
        tableAttr: {},
        showPagination: false,
        useField: false,
        tableData: state.oemCodeInfo?.etka || [],
        tableColumn: etkaTableColumns,
        tableListApi: '',
        tableListParams: '',
        tableDetailApi: '',
        tableDeleteApi: '',
        tableUpdateApi: '',
        tableExportApi: '',
        tableExportPathKey: 'http_path',
        tableDeleteParams: {},
        tableSearch: null,
      })
      const vinTableColumns = [
        { label: '序号', type: 'index', width: 70 },
        {
          label: '部件图',
          prop: 'image',
          width: 100,
          isImg: true,
        },
        {
          label: '部件信息',
          prop: 'Part_name_zh',
          minWidth: 150,
        },
        { label: '适用品牌', prop: 'Brand_name_zh', minWidth: 150 },
        { label: '部件编码', prop: 'Partnumber', width: 120 },
        { label: '适用车型', prop: 'vehicleVin', width: 100 },
      ]
      let vinTableConfig = reactive({
        searchBtnInline: true,
        headerActions: {
          list: [''],
        },
        tableAttr: {},
        showPagination: false,
        useField: false,
        tableData: state.oemCodeInfo?.vin || [],
        tableColumn: vinTableColumns,
        tableListApi: '',
        tableListParams: '',
        tableDetailApi: '',
        tableDeleteApi: '',
        tableUpdateApi: '',
        tableExportApi: '',
        tableExportPathKey: 'http_path',
        tableDeleteParams: {},
        tableSearch: null,
      })

      const handleSearch = (code) => {
        state.dialogTitle = code
        state.oemCodeInfo = {}
        getRequest('/product/oemInfo', {
          oem_code: code,
        }).then((res) => {
          console.log('res', res)
          state.oemCodeInfo = res.aph_result
          if (res.aph_result?.etka?.length) {
            etkaTableConfig.tableData = res.aph_result.etka.map((item) => {
              if (item?.part?.image) {
                item.part.image = `${baseImg}${item.part.image}`
                item.part.partInfo = item.part.parts?.find((v) => {
                  return v.oem == code
                })
              }
              return item
            })
            state.activeName = 'etka'
          } else if (res?.aph_result?.ford) {
            state.activeName = 'ford'
          } else if (res.aph_result?.vin?.length) {
            state.activeName = 'vin'
          } else {
            state.activeName = 'etka'
          }
          if (res.aph_result?.vin?.length) {
            vinTableConfig.tableData = res.aph_result.vin.map((item) => {
              if (item?.Part_img) {
                item.image = `https://images.17vin.com/img/${item.Epc}/${item.Part_img}`
              }
              return item
            })
          }
          state.dialogVisible = true
        })
      }

      const handleClsoeDialog = () => {
        emit('close')
      }

      const handleGetVinVehicle = (item) => {
        getRequest('product/oemModels', {
          oem: item.Partnumber,
          group_id: item.Group_id,
        }).then((res) => {
          state.gridData = res.aph_result?.ModelListStd || []
          console.log('res :>> ', res)
        })
      }
      return {
        typeList,
        baseFordInfo,
        fordImgList,
        fordAdaptParts,
        fordColumns,
        etkaTableConfig,
        vinTableConfig,
        ...toRefs(state),
        t,
        handleSearch,
        handleClsoeDialog,
        handleGetVinVehicle,
      }
    },
  })
</script>

<style lang="scss" scoped></style>
